import clsx from 'clsx';
import { Tooltip } from 'flowbite-react';
import { CSSProperties, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon from '../icon/icon';

export interface InputAutocompleteOptionProps {
    value: string;
    label: string;
    style?: CSSProperties;
    className?: string;
    action?(value: string): void;
    multiple?: boolean;
    selected?: boolean;
    dataTestId?: string;
    disabled?: boolean;
    hasDeviceField?: string;
    noDeviceMessage?: string;
    deviceStatus?: boolean;
    tachographIcon?: React.ReactNode;
    /** Index used by virtualizers (TanStack measureElement reads data-index) */
    dataIndex?: number;
}
export const InputAutocompleteOption = forwardRef<HTMLDivElement, InputAutocompleteOptionProps>(
    (
        {
            value,
            label,
            style,
            className,
            action,
            multiple = false,
            selected = false,
            dataTestId = 'option-input-autocomplete',
            disabled = false,
            hasDeviceField,
            noDeviceMessage,
            deviceStatus,
            tachographIcon,
            dataIndex,
        },
        ref,
    ) => {
        return (
            <div
                ref={ref}
                data-value={value}
                data-index={dataIndex}
                style={style}
                className={clsx(
                    'py-1',
                    className,
                    `${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`,
                    `${!deviceStatus ? '!cursor-default' : 'cursor-pointer'}`,
                )}
                role="button"
                tabIndex={disabled ? -1 : 0}
                onClick={() => {
                    return !disabled ? action && action(label !== value ? value : label) : null;
                }}
                onKeyDown={(evt) => {
                    if (!disabled && (evt.key === 'Enter' || evt.key === ' ')) {
                        evt.preventDefault();
                        action && action(label !== value ? value : label);
                    }
                }}
                data-test-id={dataTestId}
            >
                {multiple && (
                    <Icon
                        className={twMerge('mr-2', selected ? 'text-primary' : 'text-gray-100')}
                        name={selected ? 'ri-checkbox-fill' : 'ri-checkbox-blank-line'}
                        size={16}
                    />
                )}
                {hasDeviceField && hasDeviceField === 'hasTachographIcon' && tachographIcon}
                <span
                    style={{
                        opacity: hasDeviceField && hasDeviceField === 'hasDevice' && !deviceStatus ? '0.40 ' : '',
                    }}
                >
                    {label}
                </span>
                {!deviceStatus && hasDeviceField && hasDeviceField === 'hasDevice' && (
                    <div className="flex items-center justify-end ml-auto mr-3 !cursor-pointer">
                        <Tooltip content={noDeviceMessage} className="max-w-sm " style={'dark'} placement="left">
                            <Icon className="text-primary-400 " name="ri-information-fill" size={19} />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    },
);

InputAutocompleteOption.displayName = 'InputAutocompleteOption';

export default InputAutocompleteOption;
